export default function getAllModels() {
  const routesContext = require.context('@app2/models', false, /^\.\/.*\.js$/);
  return routesContext.keys().map(modelName => routesContext(modelName).default);
}
